import { render, staticRenderFns } from "./ShoppingCreateEdit.vue?vue&type=template&id=366da174&scoped=true&"
import script from "./ShoppingCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ShoppingCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366da174",
  null
  
)

export default component.exports